export const firebaseConfig = {
  apiKey: 'AIzaSyCpNoy4UOJOouZ05nAF12dic0pKwrJpPCE',
  authDomain: 'unitv-9b008.firebaseapp.com',
  databaseURL: 'https://unitv-9b008.firebaseio.com',
  projectId: 'unitv-9b008',
  storageBucket: 'unitv-9b008.appspot.com',
  messagingSenderId: '444266393670',
  appId: '1:444266393670:web:77ba9bb1dbcfcf45',
};

// export const firebaseConfig = {
//   apiKey: 'AIzaSyBuYTQVFDmdXSyMht9M5-Xk0Y1Czqh77RA',
//   authDomain: 'unitv-dev.firebaseapp.com',
//   databaseURL: 'https://unitv-dev.firebaseio.com',
//   projectId: 'unitv-dev',
//   storageBucket: 'unitv-dev.appspot.com',
//   messagingSenderId: '955424039591',
//   appId: '1:955424039591:web:0c310ae81c798811'
// };
